import React, { FC } from "react";
import { Screenshot } from "../../../models/applications/applicationInterfaces";
import "./taskViewer.scss";
import api from "../../../utils/api";
import { useDispatch } from "react-redux";
import { systemMessageSlice } from "../../../models/systemMessageSlice";
import { LockFill } from "react-bootstrap-icons";
import { articleTypeToIcon, handleFileRedirect } from "../../../utils/helpers";

interface Props {
  screenshots: Screenshot[];
}
const ScreenshotViewer: FC<Props> = ({ screenshots }) => {
  const dispatch = useDispatch();

  async function downloadDocument(uuid: string) {
    try {
      const res: any = await api.post(
        `/onboarding-applications/screenshots/${uuid.toString()}/signed-url`
      );
      // If the browser is Safari, we need to redirect the user to the file because Safari blocks pop-ups
      handleFileRedirect(res.data.url);
    } catch (e) {
      dispatch(
        systemMessageSlice.actions.setMessage({
          message: "Error - Unable to access document. Please try again.",
          type: "danger",
        })
      );
    }
  }

  if (!screenshots.length) {
    return null;
  }

  return (
    <>
      <div className="row">
        <div className="col-sm-12 mb-4">
          <div className="d-flex align-items-center">
            {/* Completion Icon */}
            <div className={"task-count complete"}>
              <span className="oi oi-check"></span>
            </div>
            {/* Title */}
            <p className="text-tertiary h2 mb-0" style={{ fontWeight: 750 }}>
              Application Snapshots
            </p>
          </div>
        </div>
        {screenshots.map((screenshot) => (
          <>
            {/* File and Description Block */}
            <div className="col-sm-12 col-md-4">
              <div key={screenshot.uuid} className="mb-1">
                <div className="file-container">
                  <div className="dropdown">
                    <div
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      className="d-flex"
                      style={{ userSelect: "none" }}
                    >
                      <img
                        src={articleTypeToIcon["IMAGE"]}
                        className="my-auto"
                      />
                      <div
                        className="col"
                        style={{
                          overflowX: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <span>{screenshot.s3Key.split("/").pop()}</span>
                      </div>
                      <ion-icon
                        name="ellipsis-vertical"
                        style={{ height: "auto" }}
                      />
                    </div>
                    <div
                      className="dropdown-menu dropdown-menu-right"
                      aria-labelledby="dropdownMenu2"
                    >
                      <a
                        className="dropdown-item"
                        href="javascript:void(0);"
                        onClick={() => downloadDocument(screenshot.uuid)}
                      >
                        View
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Task Description */}
            <div className="col-sm-12 col-md-8 mt-3 mt-sm-0">
              <p className="font-weight-bold h5 mb-0 text-textGray">
                {screenshot.slug}
              </p>
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default ScreenshotViewer;
